(function() {
    'use strict';

    angular
        .module('papp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
